import { render, staticRenderFns } from "./DashBoardPerformance.vue?vue&type=template&id=100f81ff&scoped=true"
import script from "./DashBoardPerformance.vue?vue&type=script&lang=js"
export * from "./DashBoardPerformance.vue?vue&type=script&lang=js"
import style0 from "./DashBoardPerformance.vue?vue&type=style&index=0&id=100f81ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f81ff",
  null
  
)

export default component.exports